import script from "./rolling-text.global.vue?vue&type=script&lang=js"
export * from "./rolling-text.global.vue?vue&type=script&lang=js"

export default script